import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';

interface UpdateData extends Types.IApi.Update.Request {
  id: string;
}

const useUpdate = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ id, ...data }: UpdateData) => {
      const response = await Api.update(id, data);
      return response.data.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['collections'] });
      queryClient.invalidateQueries({ queryKey: ['test'] });
      queryClient.invalidateQueries({ queryKey: ['collections', 'single', variables.id] });
      toast.success('Collection updated', {
        description: 'Collection has been updated successfully.',
      });
    },
    onError: (error: any) => {
      toast.error('Error', {
        description: error?.response?.data?.message || 'Failed to update collection',
      });
    },
  });
};

export default useUpdate;
